// extracted by mini-css-extract-plugin
export default {"workRightManual":"workRightManual_workRightManual__D8KK6","workRightManual_countRows":"workRightManual_workRightManual_countRows__zKRHk"};